import { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { ASSETS } from "../lib/api";

export default function Logo({ size = 56, withText = true, className = "" }) {
  const navigate = useNavigate();
  const clicks = useRef(0);
  const timer = useRef(null);

  const onClick = () => {
    clicks.current += 1;
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(() => { clicks.current = 0; }, 3000);
    if (clicks.current >= 3) {
      clicks.current = 0;
      navigate("/admin/login");
    }
  };

  return (
    <button
      type="button"
      onClick={onClick}
      className={`flex items-center gap-3 group ${className}`}
      data-testid="site-logo"
      aria-label="Ro-Dental Cluj-Napoca — acasă"
    >
      <span
        className="relative inline-flex items-center justify-center rounded-full bg-brand-yellow ring-4 ring-brand-yellow/30 shadow-soft overflow-hidden transition-transform duration-300 group-hover:scale-105"
        style={{ width: size, height: size }}
      >
        <img
          src={ASSETS.emblem}
          alt="Sigla CMI. Dr. Biriș Cornelia — Ro-Dental Cluj-Napoca"
          draggable={false}
          className="absolute inset-0 w-full h-full object-cover scale-110"
          onContextMenu={(e) => e.preventDefault()}
        />
      </span>
      {withText && (
        <span className="flex flex-col leading-tight">
          <span className="font-display font-extrabold text-brand-navy text-lg sm:text-xl tracking-tight">Ro-Dental Cluj-Napoca</span>
          <span className="text-[11px] text-brand-red font-semibold">CMI. Dr. Biriș Cornelia</span>
        </span>
      )}
    </button>
  );
}
